<template>
  <v-date-picker
    :value="getRange(query)"
    @input="onChange"
    mode="range"
    color="green"
    :input-props="{
      placeholder
    }"
    :popover="{
      visibility: 'focus'  
    }"
    :locale="{
      id: 'en',
      masks: {
        input: 'MM/DD/YYYY',
        data: 'MM/DD/YYYY'
      }  
    }"
  >
    <input
      slot-scope="{ inputProps, inputEvents }"
      class="form-control"
      :placeholder="placeholder"
      v-bind="inputProps"
      v-on="inputEvents"
      @keydown="onKeyDown"
    />
  </v-date-picker>
</template>
<script>
import Vue from "vue";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import { VueDataTablesFiltersMixin } from "vue-datatables.net";
import moment from "moment";

export default Vue.extend({
  name: 'DatatablesFilterDateRange',
  mixins: [VueDataTablesFiltersMixin],
  components: {
    'v-date-picker': DatePicker
  },
  data() {
    return {
      firstRun: false,
    }
  },
  props: {
    placeholder: {
      type: String
    },
  },
  methods: {
    onChange(value) {
      if (!value) return;

      const {start, end} = value;
      const formatStartDate = this.formatDate(start);
      const formatEndDate = this.formatDate(end);

      this.query = `${formatStartDate}-${formatEndDate}`;
      this.$emit('selected', { start: formatStartDate, end: formatEndDate });
    },
    getRange(value) {
      if (!value) return;

      const [start, end] = value.split('-');

      return {
        start: moment(start, 'MM/DD/YYYY').toDate() || null,
        end: moment(end, 'MM/DD/YYYY').toDate() || null      
      };
    },
    onKeyDown(e) {
      if (e.keyCode === 13) {
        if (e.target.value === '') {
          e.preventDefault();

          this.query = '';
          this.$emit('selected', {});

          return false;
        }
      }
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
  },
  mounted() {

  },
});
</script>
